<template>
  <div class="services">
    <nav class="sub-menu">
      <span class="button-wrapper centered" @click="addService"><a class="button is-info">+</a>Услуга</span>
      <ul class="centered">
        <li v-for="item in services" @click="handleGetService">
          <router-link :to="{ name: 'Service', params: { id: item.id } }"
          active-class="is-active" :key="item.id"
          :class="!$route.params.id && item.id === services[0].id ? 'is-active' : '' "
          >
            {{item.title}}
          </router-link>
        </li>
      </ul>
    </nav>
    <Service v-if="service" />
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import Service from 'components/Services/Service'

  export default {
    name: 'Services',
    data () {
      return {
      }
    },
    computed: {
      ...mapState(['services', 'service'])
    },
    methods: {
      ...mapActions(['getServices', 'getPromosForServices', 'addService', 'getService']),
      handleGetService () {
        const id = this.$route.params.id
        if (id !== 'new') {
          this.getService(id)
        }
      }
    },
    created () {
      this.getServices(this.$route.params.id, true)
      this.getPromosForServices()
      if (this.$route.params.id && !this.service) {
        this.getService(this.$route.params.id)
      }
    },
    components: { Service }
  }
</script>

<style>
.sub-menu {
  display: flex;
  flex-direction: column;
  max-width: 200px;
}

.sub-menu ul li {
  padding: 0 10px;
  width: 100%;
}

.sub-menu ul li a {
  padding: 10px;
  display: inline-block;
}

.services .page-header-wrapper {
  background: #eeeeee;
}

.services .page-header-wrapper {
  height: 400px;
}

.caption {
  text-align: center;
  margin: 20px 0;
}

.centered {
  display: flex;
  align-items: center;
  justify-content: center;
}

.advantages .button-wrapper,
.calculator-option .switch {
  justify-content: center;
}

.principles {
  padding: 10px;
}

.rates,
.learn-more,
.promo-wrapper,
.calculator-option {
  background: #eeeeee;
  padding: 30px;
}

.is-active {
  border-bottom: 3px solid #7957d5;
  display: inline-block;
  padding-bottom: calc(0.75rem - 3px);
}

.switch-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// Index.vue?e7b0a068